import { isNull } from '@/shared/utils/utils';

export const boolFilter = (value?: boolean, displayFalse = false) => {
    if (isNull(value)) { return value; }

    const falseKey = displayFalse
        ? 'No'
        : ''

    return value ? 'Yes' : falseKey;
}
